import {
  Outlet,
  Route,
  Routes,
  useNavigate,
  useLocation,
  Navigate,
} from 'react-router-dom';
import {useEffect, useState} from 'react';
import styles from './simulator.module.scss';
import {Configuration, Subscriptions, VirtualMoney} from './tabs';
import {NavTabsEnum} from 'utils/constants';
import {useVisibleSubTabs} from 'utils/useVisibleSubTabs';

const SIMULATOR_SUBTABS = [
  {key: 'configuration', label: 'Configuration'},
  {key: 'subscriptions', label: 'Subscriptions'},
  {key: 'virtual-money', label: 'Virtual Money'},
];

const SimulatorLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState('configuration');
  const {visibleSubTabs, visibleKeys, firstVisible} = useVisibleSubTabs(
    NavTabsEnum.Simulator,
    SIMULATOR_SUBTABS,
  );

  useEffect(() => {
    const path = location.pathname.split('/').pop();
    if (path === 'simulator' || path === '') {
      setActiveTab('configuration');
    } else {
      setActiveTab(path);
    }
  }, [location]);

  // Redirect away from a sub-tab the admin can't access.
  useEffect(() => {
    if (firstVisible && !visibleKeys.includes(activeTab)) {
      navigate(firstVisible.key);
    }
  }, [firstVisible, visibleKeys, activeTab, navigate]);

  const handleTabChange = tab => {
    setActiveTab(tab);
    navigate(tab);
  };

  return (
    <div>
      <div className={styles['details-toggler']}>
        {visibleSubTabs.map(tab => (
          <span
            key={tab.key}
            className={activeTab === tab.key ? styles['active-toggle'] : ''}
            onClick={() => handleTabChange(tab.key)}>
            {tab.label}
          </span>
        ))}
      </div>
      <Outlet />
    </div>
  );
};

export const SimulatorRoutes = () => {
  return (
    <Routes>
      <Route element={<SimulatorLayout />}>
        <Route index element={<Navigate to="configuration" replace />} />
        <Route path="configuration" element={<Configuration />} />
        <Route path="subscriptions" element={<Subscriptions />} />
        <Route path="virtual-money" element={<VirtualMoney />} />
      </Route>
    </Routes>
  );
};
